import { useCallback, useEffect, useState } from 'react';
import {
  ASK_PROVIDER_CHANGE_EVENT,
  ASK_PROVIDER_OPTIONS,
  askProviderLabel,
  isValidAskProvider,
  normalizeAskProvider,
  readAskProvider,
  writeAskProvider,
  dispatchAskProviderChange,
} from '../utils/askProviderStorage';

export function useAskProvider() {
  const [askProvider, setAskProviderState] = useState(readAskProvider);

  useEffect(() => {
    const syncFromStorage = () => {
      setAskProviderState(readAskProvider());
    };
    const onCustomChange = event => {
      const next = event?.detail?.provider;
      if (next && isValidAskProvider(next)) {
        setAskProviderState(next);
        return;
      }
      syncFromStorage();
    };

    window.addEventListener('storage', syncFromStorage);
    window.addEventListener(ASK_PROVIDER_CHANGE_EVENT, onCustomChange);
    return () => {
      window.removeEventListener('storage', syncFromStorage);
      window.removeEventListener(ASK_PROVIDER_CHANGE_EVENT, onCustomChange);
    };
  }, []);

  const setAskProvider = useCallback(nextProvider => {
    if (!isValidAskProvider(nextProvider)) return;
    const normalized = writeAskProvider(nextProvider);
    setAskProviderState(normalized);
    dispatchAskProviderChange(normalized);
  }, []);

  return {
    askProvider: normalizeAskProvider(askProvider),
    setAskProvider,
    askProviderLabel: askProviderLabel(askProvider),
    ASK_PROVIDER_OPTIONS,
  };
}
